import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { initializeI18n } from './i18n';
import { installIosKeyboardViewportFix } from './iosKeyboardViewportFix';

import '@fontsource/source-sans-pro/400.css';
import '@fontsource/source-sans-pro/600.css';
import '@fontsource/source-sans-pro/700.css';
import '@fontsource/bitter/700.css';

let removeViewportFix: (() => void) | undefined;

const renderApp = () => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </React.StrictMode>,
  );
  reportWebVitals();
  // Pins the app to the visual viewport when the iOS keyboard opens.
  // Not installed at all outside iOS. Tear down any previous install first so
  // a re-render can't stack duplicate visualViewport listeners.
  removeViewportFix?.();
  removeViewportFix = installIosKeyboardViewportFix();
};

initializeI18n().then(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
